export enum SvgActions {
  Reset = 'reset',
  Plus = 'plus',
  Minus = 'minus',
  Render = 'render',
  SetZoom = 'setZoom',
  ClearZoom = 'clearZoom',
  DisablePan = 'disablePan',
  EnablePan = 'enablePan'
}